import { QueryClient } from '@tanstack/react-query';

/** The shared React Query client. Sensible defaults for a small dashboard: no aggressive refetch. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});
